import normalizeProjectPath from "../../../gd/utils/normalize-project-path";

export default function mapProject(companyId, parentProject, projectName) {

    // NEW (path i.e. FOLDER > SUBFOLDER

    projectName = normalizeProjectPath(projectName)

    const project = gd.session.projects.findByFullPath(projectName)
    if (project) {
        return project.id;
    }

    return null;

    // OLD

    // const companyTree = gd.tree.getCompany(companyId);
    //
    // // const projects = companyTree.projects;
    //
    // const projects = gd.session.projects.filterByCompany(companyId).models;
    //
    // const project = _.find(projects,project=>{
    //     return project.name.toLowerCase()===projectName.trim().toLowerCase();
    // });
    //
    // if (project) {
    //     return project.id;
    // }
    //
    // return null;


}